import { useTranslation } from 'react-i18next';
import DividerWithText from '../../../../../components/DividerWithText';
import PhotoPickerSummary from '../../../../../components/PhotoPicker/PhotoPickerSummary';
import SummaryContainer from '../../Components/SummaryContainer';
import SummaryFieldsUser from '../../Components/SummaryFieldsUser';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param user
 * @param photoPicker
 */
const SummaryEmployeeContractor = (
    {
        user,
        photoPicker
    }
) => {

    const { t } = useTranslation();

    return (
        <div className="px-2">
            <DividerWithText title={t('take_photography')} />
            <PhotoPickerSummary
                photoPicker={photoPicker}
                classWith={'content-center-w-400px'}
            />
            <DividerWithText title={t('employee_details')} />
            <SummaryContainer>
                <div className="row">
                    <SummaryFieldsUser
                        user={user}
                    />
                </div>
            </SummaryContainer>
        </div>
    );

}

export default SummaryEmployeeContractor
